export default __webpack_public_path__ + "static/media/python.d31ad2c9.svg";